// extracted by mini-css-extract-plugin
module.exports = {"sp-175w-I":"I_sp-175w-I__zPUoT"};